'use client';

import { LoadingButton } from '@/components/common/LoadingButton';
import { type Product } from '@/domain/products/types';
import pdf from '@/services/pdf';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import PictureAsPdfOutlined from '@mui/icons-material/PictureAsPdfOutlined';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import { RepositoryDocumentFrame } from '../RepositoryDocumentFrame';

interface BusinessModelTabProps {
  detailedProduct: Product;
}

const BusinessModelTab = ({ detailedProduct }: BusinessModelTabProps) => {
  const [isLoadingPDF, setIsLoadingPDF] = useState(false);

  const exportPDF = useCallback(async () => {
    try {
      setIsLoadingPDF(true);
      await pdf.downloadPDFAsync(`/pdf/from-repository/${detailedProduct.businessModels}`, detailedProduct.product);
      toast.success('Business Model downloaded successfully');
    } finally {
      setIsLoadingPDF(false);
    }
  }, [detailedProduct]);

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <RepositoryDocumentFrame product={detailedProduct} documentPath={detailedProduct.businessModels} />
      <LoadingButton loading={isLoadingPDF} icon={<PictureAsPdfOutlined />} variant="outlined" onClick={exportPDF}>
        Export PDF
      </LoadingButton>
    </Box>
  );
};

export default BusinessModelTab;
